module.exports = __webpack_public_path__ + "static/media/manzo_08_thumb.a5abf266.png";